module.exports = __webpack_public_path__ + "img/PG3-3-311x208.21ba53b1.png";